import { render, staticRenderFns } from "./ringkasanpendapatanAIR.vue?vue&type=template&id=5a192b56"
import script from "./ringkasanpendapatanAIR.vue?vue&type=script&lang=js"
export * from "./ringkasanpendapatanAIR.vue?vue&type=script&lang=js"
import style0 from "./ringkasanpendapatanAIR.vue?vue&type=style&index=0&id=5a192b56&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports